import React, { useState, useEffect } from "react";
import "./styles.css";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { redirect } from "react-router-dom";
import { API_BASE } from "../../api";

export default function App() {
  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    stateId: "",
    districtId: ""
  });
  const [states, setStates] = useState('');
  const [districts, setDistricts] = useState('');
  const [statename, setStateName] = useState('Select State');
  const [stateId, setStateId] = useState('');
  const [distName, setDistName] = useState('Select District');
  const [distId, setDistId] = useState('');
  const [loading, setLoading] = useState(true);

  const registerUser = (values) => {
    const url = `${API_BASE}/register`;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(values)
    }
    fetch(url, options)
      .then(response => response.json())
      .then(data => {
        alert(data.message);
        // window.location.reload();
        redirect("/form");
      })
      .catch(err => {
        console.log("Error: ", err)
        alert(err);
      });
  }

  useEffect(() => {
    fetch(`${API_BASE}/states`)
      .then((response) => response.json())
      .then((data) => {
        setStates(data.result);
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching states:", error));
  }, [])

  useEffect(() => {
    fetch(`${API_BASE}/districts?state_id=${stateId}`)
      .then((response) => response.json())
      .then((data) => {
        setDistricts(data?.result?.districtList);
        setLoading(false);

      })
      .catch((error) => console.error("Error fetching states:", error));
  }, [stateId]);
  const handleState = (event) => {
    const selectedName = states.find((state) => state.id === event.target.value)?.name;

    setStateName(selectedName);
    setStateId(event.target.value);

  };

  const handleDist = (event) => {
    const selectedName = districts.find((dist) => dist.id === event.target.value)?.name;

    setDistName(selectedName);
    setDistId(event.target.value);
  };
  const handleInputChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setValues((values) => ({
      ...values,
      [name]: value
    }));
  };

  const [submitted, setSubmitted] = useState(false);
  const [valid, setValid] = useState(false);
  const [gender, setGender] = useState("");

  const handleChange = (event) => {
    setGender(event.target.value);
  };

  const handleSubmit = (e) => {
    values.stateId = stateId;
    values.districtId = distId;
    values.gender = gender;
    if (values.name && values.email && values.phone && values.stateId && values.districtId && values.gender && values.password) {
      setValid(true);
      registerUser(values);

    }
    setSubmitted(true);
  };

  return (
    <>
      <h2>Create New User</h2>

      <div className="form-container">
        <form className="register-form" onSubmit={handleSubmit}>
          {!valid && (
            <input
              className="form-field"
              type="text"
              placeholder="Name"
              name="name"
              value={values.name}
              onChange={handleInputChange}
            />
          )}

          {submitted && !values.name && (
            <span className="error-msg">Please Enter Name</span>
          )}

          {!valid && (
            <input
              className="form-field"
              type="email"
              placeholder="Email"
              name="email"
              value={values.email}
              onChange={handleInputChange}
            />
          )}

          {submitted && !values.email && (
            <span className="error-msg">Please enter an email address</span>
          )}

          {!valid && (
            <input
              className="form-field"
              type="contact"
              placeholder="Contact Number"
              name="phone"
              value={values.phone}
              onChange={handleInputChange}
            />
          )}

          {submitted && !values.email && (
            <span className="error-msg">Please enter contact Number</span>
          )}
          <FormControl className="form-field">
            <Select
              name="State"
              value={statename}
              onChange={handleState}
              style={{ backgroundColor: "white", color: "#917981", fontSize: "18px", marginTop: "10px", marginBottom: "15px", borderRadius: "0px !important" }}
            >
              <MenuItem value={statename} disabled>
                <em>{statename}</em>
              </MenuItem>
              {(loading === false && states) ? (states?.map((state) => (
                <MenuItem key={state.id} value={state.id} >
                  {state.name}
                </MenuItem>
              ))) : null}
            </Select>
          </FormControl>

          <FormControl className="form-field">
            <Select
              name="district"
              value={distName}
              onChange={handleDist}
              style={{ backgroundColor: "white", color: "#917981", fontSize: "18px", marginBottom: "15px" }}
            >
              <MenuItem value={distName} disabled>
                <em>{distName}</em>
              </MenuItem>
              {(loading === false && districts) ? (districts?.map((dist) => (
                <MenuItem key={dist.id} value={dist.id}>
                  {dist.name}
                </MenuItem>
              ))) : null}
            </Select>
          </FormControl>
         
          {!valid && (
            <input
              className="form-field"
              type="password"
              placeholder="Password"
              name="password"
              value={values.password}
              onChange={handleInputChange}
            />
          )}

          {submitted && !values.email && (
            <span className="error-msg">Please enter password</span>
          )}

<div style={{ display: "flex", justifyContent: "space-around" }}>
            <div style={{ display: "flex" }}>
              <input
                type="radio"
                name="gender"
                value="male"
                placeholder="Male"
                checked={gender === "male"}
                onChange={handleChange}
              />
              <span className="gender_radio">Male</span>
            </div>
            <div style={{ display: "flex" }}>
              <input
                type="radio"
                name="gender"
                value="female"
                checked={gender === "female"}
                onChange={handleChange}
              />
              <span className="gender_radio">Female</span>
            </div>
            <div style={{ display: "flex" }}>
              <input
                type="radio"
                name="gender"
                value="other"
                checked={gender === "other"}
                onChange={handleChange}
              />
              <span className="gender_radio">Other</span>
            </div>
          </div>

          {
            !valid && (
              <button className="form-field" type="submit">
                Register
              </button>
            )
          } 
        </form >
      </div >
    </>
  );
}
